import { render } from "./DepartmentSection.vue?vue&type=template&id=6d41845d&scoped=true&ts=true"
import script from "./DepartmentSection.vue?vue&type=script&lang=ts"
export * from "./DepartmentSection.vue?vue&type=script&lang=ts"

import "./DepartmentSection.vue?vue&type=style&index=0&id=6d41845d&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d41845d"]])

export default __exports__